import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  scroll() {
    const cell = document.querySelector<HTMLElement>('.grid-item.today, .timeline-item.today');
    if (cell) {
      cell.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    }
  }
}
